/** Status dropdown options for list screens (all / active / inactive). */
export const ACTIVE_STATUS_FILTERS = (allLabel = "All") => [
  { id: "all", label: allLabel },
  { id: "active", label: "Active", status: 1 },
  { id: "inactive", label: "Inactive", status: 0 },
];

export const statusFromFilter = (filterId, options = []) => {
  if (!filterId || filterId === "all") return "";
  const opt = options.find((o) => o.id === filterId);
  return opt?.status !== undefined ? opt.status : "";
};

export const emptyMessageForStatus = (filterId, { all, active, inactive } = {}) => {
  if (filterId === "active") return active || "No active records";
  if (filterId === "inactive") return inactive || "No inactive records";
  return all || "No records yet";
};
